import React, { useState } from "react";
import styled from "styled-components";
import { SHIPMENT_STATUS, SERVER_STATUS, C } from "./requestsShared";
import ShipmentRequestsPanel from "./ShipmentRequestsPanel";
import ServerRequestsPanel from "./ServerRequestsPanel";

const Page = styled.div`
  max-width: 1240px;
  margin: 0 auto;
  padding: 8px 24px 32px;
  color: ${C.ink};
`;

const Header = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
  padding: 12px 4px 0;
  flex-wrap: wrap;
`;

const Title = styled.h4`
  margin: 0;
  font-weight: 600;
`;

const Subtitle = styled.span`
  font-size: 13px;
  color: ${C.muted};
`;

const Controls = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 20px;
  flex-wrap: wrap;
  margin-top: 14px;
  border-bottom: 1px solid ${C.border};
`;

const Tabs = styled.div`
  display: flex;
  gap: 24px;
`;

const Tab = styled.button`
  appearance: none;
  border: none;
  background: none;
  cursor: pointer;
  font: inherit;
  font-weight: 500;
  color: ${(p) => (p.active ? C.ink : C.muted)};
  padding: 10px 0 12px;
  position: relative;

  &:focus,
  &:focus-visible {
    outline: none;
  }

  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 2px;
    background: ${(p) => (p.active ? C.accent : "transparent")};
    border-radius: 2px 2px 0 0;
  }
`;

const Filter = styled.label`
  margin-left: auto;
  margin-bottom: 8px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: ${C.surface};
  border: 1px solid ${C.borderStrong};
  border-radius: 8px;
  padding: 6px 10px;
  color: ${C.muted};
  font-size: 13px;

  select {
    appearance: none;
    border: none;
    background: none;
    font: inherit;
    color: ${C.ink};
    cursor: pointer;
    outline: none;
  }
`;

const TAB_STATUS_OPTIONS = {
  erp: SHIPMENT_STATUS,
  srv: SERVER_STATUS,
};

const Requests = () => {
  const [tab, setTab] = useState("erp");
  const [status, setStatus] = useState("");

  const switchTab = (next) => {
    setTab(next);
    setStatus("");
  };

  const statusOptions = TAB_STATUS_OPTIONS[tab];

  return (
    <Page>
      <Header>
        <Title>Requisições</Title>
        <Subtitle>Inspetor de integração — chamadas do ERP e envios ao servidor central</Subtitle>
      </Header>

      <Controls>
        <Tabs>
          <Tab active={tab === "erp"} onClick={() => switchTab("erp")}>Requisições de carga</Tab>
          <Tab active={tab === "srv"} onClick={() => switchTab("srv")}>Envios ao servidor</Tab>
        </Tabs>
        <Filter>
          Status:
          <select value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="">Todos</option>
            {Object.entries(statusOptions).map(([key, cfg]) => (
              <option key={key} value={key}>{cfg.label}</option>
            ))}
          </select>
        </Filter>
      </Controls>

      {tab === "erp"
        ? <ShipmentRequestsPanel key={`erp-${status}`} status={status} />
        : <ServerRequestsPanel key={`srv-${status}`} status={status} />}
    </Page>
  );
};

export default Requests;
